import { apiClient } from 'modules/apiClient';
import { SettingsDefaults } from 'modules/settings/types';
import { Boat } from '../types';

const getBoats = async (): Promise<Boat[]> => {
  const response = await apiClient.get('/v1/users/boats');
  return response.data;
};

type UpdateBoatProps = {
  id: number;
  name: string;
  files: {
    polars: File | null;
    sails: File | null;
    wave: File | null;
  };
  remove?: {
    sails: boolean;
    wave: boolean;
  };
  config?: SettingsDefaults;
};

const updateBoat = async ({
  id,
  files,
  remove,
  config,
  name,
}: UpdateBoatProps): Promise<Boat> => {
  const formData = new FormData();
  formData.append('name', name);
  if (files.polars) {
    formData.append('polars', files.polars);
  }
  if (files.sails) {
    formData.append('sails', files.sails);
  }
  if (files.wave) {
    formData.append('wave', files.wave);
  }
  // Only sent when removing an existing file and not replacing it.
  if (remove?.sails && !files.sails) {
    formData.append('removeSails', 'true');
  }
  if (remove?.wave && !files.wave) {
    formData.append('removeWave', 'true');
  }
  if (config) {
    formData.append('config', JSON.stringify(config));
  }
  const response = await apiClient.patch(`/v1/boats/${id}`, formData);
  return response.data;
};

type CreateBoatProps = {
  name: string;
  files: {
    polars: File | null;
    sails: File | null;
    wave: File | null;
  };
  config?: SettingsDefaults;
};

const createBoat = async ({
  files,
  config,
  name,
}: CreateBoatProps): Promise<Boat> => {
  const formData = new FormData();
  formData.append('name', name);
  if (files.polars) {
    formData.append('polars', files.polars);
  }
  if (files.sails) {
    formData.append('sails', files.sails);
  }
  if (files.wave) {
    formData.append('wave', files.wave);
  }
  if (config) {
    formData.append('config', JSON.stringify(config));
  }
  const response = await apiClient.post(`/v1/boats/`, formData);
  return response.data;
};

const validateBoatFiles = async (
  file: File,
  type: 'polars' | 'sails' | 'wave',
): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  await apiClient.post(`/v1/boats/validate`, formData);
};

export const BoatsApi = { getBoats, updateBoat, createBoat, validateBoatFiles };
